
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFilter, faInfoCircle, faSearch, faTimes, faCog } from '@fortawesome/free-solid-svg-icons'

import Checkbox from '@mui/material/Checkbox'
import FormControlLabel from '@mui/material/FormControlLabel'
import { useMatomo } from '@jonkoops/matomo-tracker-react'

import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Popover from 'react-bootstrap/Popover';
import Tooltip from 'react-bootstrap/Tooltip'

import React, { Fragment as F, useContext, useEffect, useRef, useState } from 'react'
import Modal from 'react-modal'
import Select from 'react-select'
import {
  Link,
  useParams,
} from "react-router-dom"
import { toast } from 'react-toastify'

import {
  appRouter,
  C,
  logg,
  useApiRouter,
} from '$shared'
import {
  AppCtx,
} from '$src/App'
import {
  ActionsVerticalMenu,
  FiltersBox,
} from '$src/components'
import {
  BanksCtx,
} from '$src/components/banks'
import {
  PeriodsCtx,
} from '$src/components/periods'
import {
  PdfModal,
  ReportsCtx,
} from '$src/components/reports'

library.add( faFilter, faInfoCircle, faSearch, faTimes, faCog )


/**
 * AdvancedReportsModal
**/
const AdvancedReportsModal = (props) => {
  // logg(props, 'AdvancedReportsModal')

  const apiRouter = useApiRouter()
  const { trackPageView, trackEvent } = useMatomo()

  /* ctx */

  const {
    cuEmail, currentUser,
    jwtToken,
    loading, setLoading,
    scope, setScope,
    selectedResource, setSelectedResource, defaultSelectedResource,
  } = useContext(AppCtx)
  // logg(useContext(AppCtx), 'AppCtx in AdvancedReportsModal')

  const {
    selectedBanks, setSelectedBanks,
    sortedResults,
  } = useContext(BanksCtx)
  // logg(useContext(BanksCtx), 'BanksCtx in ReportsModal')

  const {
    // periodsList,
    selectedPeriods, setSelectedPeriods,
    selectedPeriodsReverse,
  } = useContext(PeriodsCtx)
  // logg(useContext(PeriodsCtx), 'PeriodsCtx in ReportsModal')

  const {
    // sg
    advancedReport,              setAdvancedReport,
    advancedReportEditModalOpen, setAdvancedReportEditModalOpen,
    advancedReportShowModalOpen, setAdvancedReportShowModalOpen,
    pdfModalOpen, setPdfModalOpen,
    // pl
    advancedReportsList,
    advancedReportsModalOpen, setAdvancedReportsModalOpen,

    includeContacts, setIncludeContacts,
    unauthorizedContactsModalOpen, setUnauthorizedContactsModalOpen,
  } = useContext(ReportsCtx)
  // logg(useContext(ReportsCtx), 'ReportsCtx in ReportsModal')

  /* state */

  const [ fontSize, setFontSize ] = useState(12)
  const [ itemsPerRow, setItemsPerRow ] = useState(4)
  const [ portraitNotLandscape, setPortraitNotLandscape ] = useState("false")

  const [ selectedFormat, setSelectedFormat ] = useState('csv')

  const _selectedRssds = Object.keys(selectedBanks)
  const selectedRssds  = sortedResults.filter((a, idx) => _selectedRssds.indexOf(`${a.rssd}`) >= 0).map((a, idx) => a.rssd).join(',')
  const formRef = useRef(null)


  /* effects */

  useEffect(() => {
    // trackPageView()
    trackEvent({ category: 'AdvancedReportsModal', action: 'show' })
  }, [ advancedReportsModalOpen ])

  /* scope */
  const [ filteredList, setFilteredList ] = useState(advancedReportsList)
  useEffect(() => {
    const _scope = {...scope}
    // if (_scope[C.scope.company]) { _scope[C.scope.mine] = true }

    const tmp = advancedReportsList.filter((r, idx) => {
      return _scope[r.scope]
    })
    setFilteredList(tmp)
  }, [ advancedReportsList, scope ])

  /* methods */

  const handleClear = () => {
    setSelectedResource(defaultSelectedResource)
    setIncludeContacts(false)
  }

  const handleRun = () => {
    if (Object.keys(selectedBanks).length === 0) {
      toast('Please select bank(s) to run a report')
      return
    }
    if (!selectedResource.id) {
      toast('Please select which report to run')
      return
    }
    switch (selectedFormat) {
      case C.formats.web:
        setLoading(true)
        fetch(apiRouter.advancedReportRunPath({ id: selectedResource.id, format: 'json' }), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            rssds: selectedRssds,
          }),
        }).then(r => r.json()).then((result) => {
          // logg(result, 'got AdvancedReport')
          setAdvancedReport(result)
          setLoading(false)
          setAdvancedReportShowModalOpen(true)
        })
        break
      // case C.formats.pdf:
      //   window.open(apiRouter.advancedReportRunPath({ id: selectedResource.id, format: selectedFormat,
      //     fontSize, itemsPerRow, portraitNotLandscape, }), "_blank")
      //   break
      default:
        // window.location = apiRouter.advancedReportRunPath({ id: selectedResource.id, format: selectedFormat, includeContacts,  })
        toast('Generating your report - please do not close the page')
        formRef.current.submit()
    }
  }

  return <F>
    <PdfModal fontSize={fontSize} setFontSize={setFontSize}
      itemsPerRow={itemsPerRow} setItemsPerRow={setItemsPerRow}
      portraitNotLandscape={portraitNotLandscape} setPortraitNotLandscape={setPortraitNotLandscape}
    />


    <form target="_blank" ref={formRef} method="post"
        action={apiRouter.advancedReportRunPath({ format: selectedFormat, id: selectedResource.id, includeContacts })} >
      <input type="hidden" name="rssds" value={selectedRssds} />
      <input type="hidden" name="jwt_token" value={jwtToken} />
      <input type="hidden" name="periods" value={Object.keys(selectedPeriods).join(',')} />
      <input type="hidden" name="periods_reverse" value={selectedPeriodsReverse} />
      <input type="hidden" name="fontSize" value={fontSize} />
      <input type="hidden" name="itemsPerRow" value={itemsPerRow} />
      <input type="hidden" name="portraitNotLandscape" value={portraitNotLandscape} />
    </form>


    <Modal
      ariaHideApp={false}
      className="Boxed2Modal BaseModal DoL"
      isOpen={advancedReportsModalOpen}
      onRequestClose={() => {
        handleClear()
        setAdvancedReportsModalOpen(false)
      } }
      overlayClassName="ReportsModalOverlay"
    >
      <div className='header'>
        <h5 >Multi Fi Reports</h5>
        <Link to='/'><div className='close' onClick={() => {
          handleClear()
          setAdvancedReportsModalOpen(false)
        } }>&times;</div></Link>
      </div>


      <div className='C1'>

        <div className='AdvancedReportsList'>
          <div className='AdvancedReportsListC'
            onClick={(event) => {
              if(event.target === event.currentTarget) {
                setSelectedResource(defaultSelectedResource)
              }
            } }
          >
            { filteredList.map((opt, idx) => <div
                className={`item-1 ${opt.value === selectedResource.id ? 'active' : ''}`}
                key={idx}
                onClick={() => setSelectedResource(opt) }
            >
              <div className='left'>
                <input checked={opt.value === selectedResource.id} type='radio' name='selected-resource'
                  readOnly={true}
                  />&nbsp;{ opt.label }
              </div>
              <div className='right'>
                { opt.email === cuEmail && 'mine' }
                { opt.email === 'reports@fedfis.com' && 'standard' }
                { [cuEmail, 'reports@fedfis.com'].indexOf(opt.email) === -1 && <F>by { opt.email }</F> }
              </div>
            </div> )}
          </div>
        </div>
        <ActionsVerticalMenu
          clear={handleClear}
          handleModify={() => {
            // setAdvancedReportEditModalOpen(true)
            // setAdvancedReportsModalOpen(false)
          } }
          kind={C.kinds.AdvancedReport}
        />
      </div>

      <FiltersBox onChange={() => setSelectedResource(defaultSelectedResource) } />

      <div className='actions'>
        <div className='left'>
          <Checkbox checked={includeContacts} onChange={(ev) => {
            setIncludeContacts(ev.target.checked)
            setSelectedFormat('csv')
          } }/>
          <label>Include Contact Information</label>
        </div>
        <div className='right'>

          { includeContacts && <div className='gray'>Only csv export is available<br />with contacts</div> || <div className='formatW'>
            <label>Format&nbsp;&nbsp;</label>
            <Select className='select2'
              isSearchable={false}
              menuPlacement={'top'}
              onChange={(ev) => setSelectedFormat(ev.value)}
              options={C.formatOpts}
              style={C.select2Styles}
              value={C.formatOpts.filter(e => e.value === selectedFormat)}
            />
          </div> }

          <div className='settingsW'>{ 'pdf' === selectedFormat &&
            <FontAwesomeIcon icon="fa-solid fa-cog" className=''
              style={{ cursor: 'pointer', fontSize: '28px', color: 'gray' }}
              onClick={() => {
                setPdfModalOpen(true)
              } }
            /> }
          </div>

          { Object.keys(selectedBanks).length ?
            <button disabled={!selectedResource.id} className='Btn btn-primary'
              onClick={handleRun}>Run</button> :
            <OverlayTrigger placement="top"
              overlay={<Tooltip>Please select bank(s) to run any report.</Tooltip>}
            ><button disabled={true} className='Btn btn-primary'>Run</button>
            </OverlayTrigger> }

        </div>
      </div>

    </Modal>
  </F>
}
export default AdvancedReportsModal
